module.exports = __webpack_public_path__ + "img/switch-off.78c7a36e.svg";